/** Authored layouts by id (layout.ts builds them; a zone names its own in `ZoneDef.layout`). */
import type { LayoutSpec } from '../../layout';
import { DEMO_PLAZA_LAYOUT } from './demoPlaza';
import { YANYU_LAYOUT } from './yanyu';
import { YANYU2_LAYOUT } from './yanyu2';
import { TOWN_B_LAYOUT } from './townB';
import { TOWN_C_LAYOUT } from './townC';
import { TOWN_D_LAYOUT } from './townD';
import { SECT_LAYOUTS } from './sects';
import { CITY_LAYOUTS } from './cities';

export const LAYOUTS: Readonly<Record<string, LayoutSpec>> = { yanyu: YANYU_LAYOUT, demoPlaza: DEMO_PLAZA_LAYOUT, yanyu2: YANYU2_LAYOUT,
  'town-b': TOWN_B_LAYOUT,
  'town-c': TOWN_C_LAYOUT,
  'town-d': TOWN_D_LAYOUT,
  ...SECT_LAYOUTS,
  ...CITY_LAYOUTS,
};
